import ReactDOM from "react-dom/client";
import "./index.css";
import { AuthProvider } from "./Components/Auth/AuthProvider";
import routes from "./routes/routes";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import React from "react";
import { Toaster } from "react-hot-toast";

const router = createBrowserRouter(routes);

ReactDOM.createRoot(document.getElementById("root")).render(
    <AuthProvider>
      <Toaster position="top-center" />
      <RouterProvider router={router} />
    </AuthProvider>
);
